import { Avatar, Button, Modal, Paper, Stack, Typography } from '@mui/material';
import { updateFormUpdateMsg } from 'API';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PaperOnEachOther } from 'Images';

interface INewUpdateModal {
  formId: number;
  closeModal: Function;
}

export const NewUpdateModal = ({ formId, closeModal }: INewUpdateModal) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.GENERAL).newUpdate;

  const continueWithFormHandler = async () => {
    await updateFormUpdateMsg(formId);
    closeModal();
  };

  return (
    <Modal open>
      <Paper
        sx={{
          width: isDesktop ? '80%' : '90%',
          maxWidth: '550px',
          padding: isDesktop ? '40px 100px 56px 100px' : '40px 10px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          boxShadow: '0px 3px 21px 0px #2D70D926',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          display: 'flex',
          flexFlow: 'column',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: '20px',
            left: '20px',
            fontSize: '25px',
            cursor: 'pointer',
          }}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') continueWithFormHandler();
          }}
          onClick={continueWithFormHandler}
        >
          X
        </span>
        <Avatar
          alt=''
          src={PaperOnEachOther}
          sx={{ width: '64px', height: '64px' }}
        />
        <Stack
          sx={{
            m: '40px 0',
          }}
        >
          <Typography
            sx={{
              fontWeight: 'bold',
              fontSize: '24px !important',
              mb: '20px',
            }}
          >
            {dictionary.title}
          </Typography>
          <Typography>{dictionary.fromLastTime}</Typography>
          <Typography>{dictionary.needToUpdate}</Typography>
        </Stack>
        <Button onClick={continueWithFormHandler}>{dictionary.continue}</Button>
      </Paper>
    </Modal>
  );
};
